<template lang="pug">
.calendar
  div.date-summary
    div.date-container
      .box(v-for="(item,i) in dateSummaryList" :key="i" @click="handleSelectDate(item.week,item.date)" :class="ins===item.week? `select-date-${colorType}`:''")
        span.light 周{{item.week | weekFormat}}
        span {{item.day}}
    div.date-icon(@click="showCalendar")
      vant-img(:src="calendarIcon" height="1.57rem" width="1.57rem")
      vant-img.arrow-icon(:src="arrowIcon" height=".36rem" width=".64rem")
  vant-calendar(v-model="calendarShow" :round="false" position="right" :color="colorObj[colorType]" :min-date="minDate" :max-date="maxDate" :default-date="defaultDate" @confirm="handleSure")
    template(slot="title")
       vant-img(:src="closeIcon" height="1rem" width="1rem" @click="closeCalendar")
</template>

<script>
import { Calendar, Image } from 'vant'
import closeIcon from '@assets/icon/close.png'
import calendarIcon from '@assets/icon/calendar.png'
import { traceBackDays, dateObjToDate, dateToDateStr } from '@utils/time_helper'

const week = ['日', '一', '二', '三', '四', '五', '六']

const colorObj = {
  default: '#5687ff',
  red: '#F67040'
}

export default {
  components: {
    VantCalendar: Calendar,
    VantImg: Image
  },
  props: {
    colorType: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      colorObj,
      ins: new Date().getDay(),
      // arrowIcon,
      closeIcon,
      calendarIcon,
      calendarShow: false,
      selectDate: '',
      defaultDate: new Date(),
      minDate: traceBackDays(new Date(), 900),
      maxDate: traceBackDays(new Date(), -900),
      dateSummaryList: []
    }
  },
  filters: {
    weekFormat(num) {
      return week[num]
    }
  },
  computed: {
    arrowIcon() {
      if (!this.colorType) return require('@assets/icon/arrow-default.png')
      return require(`@assets/icon/arrow-${this.colorType}.png`)
    }
  },
  created() {
    this.selectDate = this.$store.state.futureDate || dateObjToDate(new Date())
    this.defaultDate = new Date(dateToDateStr(this.selectDate))
    this.dateSummary(this.defaultDate)
    const obj = this.dateSummaryList.filter(item => item.date === this.selectDate)[0]
    this.ins = obj ? obj.week : null
  },
  watch: {
    selectDate(newVal) {
      this.$emit('selectDate', newVal)
      this.$store.dispatch('saveDate', newVal)
    }
  },
  methods: {
    // 日期总览
    dateSummary(data) {
      const selectedDate = data || new Date()
      const list = [
        this.dateSummaryFormat(selectedDate)
      ]
      // 后加2天
      for (let i = 1; i < 3; i++) {
        const date = traceBackDays(selectedDate, -i)
        list.push(this.dateSummaryFormat(date))
      }
      // 前加3天
      for (let i = 1; i < 4; i++) {
        const date = traceBackDays(selectedDate, i)
        list.unshift(this.dateSummaryFormat(date))
      }
      this.dateSummaryList = list
    },
    // 打开日历选择
    showCalendar() {
      this.calendarShow = true
    },
    // 关闭日历选择
    closeCalendar() {
      this.calendarShow = false
    },
    // 日期栏选择日期
    handleSelectDate(week, date) {
      this.ins = week
      this.selectDate = date
      this.defaultDate = new Date(dateToDateStr(date))
    },
    dateSummaryFormat(date) {
      return {
        week: date.getDay(),
        day: date.getDate().toString().padStart(2, '0'),
        date: dateObjToDate(date)
      }
    },
    handleSure(data) {
      this.selectDate = dateObjToDate(data)
      this.dateSummary(data)
      const obj = this.dateSummaryList.filter(item => item.date === this.selectDate)[0]
      this.ins = obj ? obj.week : null
      this.calendarShow = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.calendar
  .date-summary
    padding-left 1rem
    height 5rem
    background-color #fff
    display flex
    align-items center
    .date-container
      flex 1
      height 100%
      // background red
      display flex
      align-items center
      justify-content space-around
      .box
        // margin-right .36rem
        width 3.36rem
        height 3.36rem
        // background-color $theme-color
        border-radius .29rem
        display flex
        flex-direction column
        justify-content space-around
        align-items center
        >span
          &:first-child
            font-size .86rem
          &:last-child
            font-size 1.14rem
            font-weight 600
    .date-icon
      box-sizing border-box
      padding .2rem 0
      width 3.14rem
      height 3.36rem
      display flex
      flex-direction column
      justify-content space-around
      align-items center
  /deep/.van-popup
    .van-calendar
      .van-calendar__weekdays
        color $light-text-color
      .van-calendar__selected-day
        height 3.86rem
        width 3.86rem
      .van-calendar__day
        font-size 1.14rem
        font-weight 600
      .van-calendar__header-title
        text-align left
        padding-left 1rem
        .van-calendar__header-subtitle
          text-align center
      .van-calendar__month-title
        background  $container-bg-color
        color $light-text-color
      .van-button
        border-radius .43rem
    .van-icon
       display none
  .select-date-default
    background #5687ff
    color #fff
    .light
      color #fff
  .select-date-red
    background #F67040
    color #fff
    .light
      color #fff

</style>
